import AMPConnector from './components/AMPConnector';
import AttachChildInput from './components/AttachChildInput';
import ButtonList from './components/ButtonList';
import Checkbox from './components/Checkbox';
import CheckBoxList from './components/CheckBoxList';
import Dropdown from './components/Dropdown';
import LiveTextEditor from './components/LiveTextEditor';
import NumericInput from './components/NumericInput';
import RadioButton from './components/RadioButton';
import TextInput from './components/TextInput';
import TableWidget from './components/TableWidget/TableWidget';

export const WIDGET_NAMES = Object.freeze({
  AMPConnector: AMPConnector.name,
  AttachChildInput: AttachChildInput.name,
  ButtonList: ButtonList.name,
  Checkbox: Checkbox.name,
  CheckBoxList: CheckBoxList.name,
  Dropdown: Dropdown.name,
  LiveTextEditor: LiveTextEditor.name,
  NumericInput: NumericInput.name,
  RadioButton: RadioButton.name,
  TextInput: TextInput.name
});

// TODO move logic out of feature module index
export default {
  AMPConnector,
  AttachChildInput,
  ButtonList,
  Checkbox,
  CheckBoxList,
  Dropdown,
  LiveTextEditor,
  NumericInput,
  RadioButton,
  TextInput,
  TableWidget
};
